import { createSelector } from 'reselect'

export const getIsMobileDevice = createSelector(
  state => state && state.common && state.common.isMobileDevice,
  isMobileDevice => isMobileDevice
)
